export default __webpack_public_path__ + "static/media/rebeca_icon.bd9288c8.svg";